import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { ShoppingBag, Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/lib/data";
import { useCart } from "@/context/CartContext";

export const Navbar = () => {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-40 bg-cream/95 backdrop-blur-sm border-b border-rosegold/15">
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-32 flex items-center justify-between gap-4">
        <div className="hidden md:flex items-center gap-7 flex-1">
          {NAV_LINKS.slice(0, 3).map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`group font-bubble font-bold text-base inline-block px-2 py-3 -my-1 ${
                pathname === l.to ? "text-maroon-dark" : "text-maroon"
              }`}
            >
              <span className="inline-block transition-transform group-hover:-translate-y-0.5 group-hover:-rotate-3">{l.label}</span>
            </Link>
          ))}
        </div>

        <div className="md:flex-1 flex md:justify-center">
          <Link to="/" data-testid="brand-logo" className="inline-flex">
            <img
              src="/hound-logo.png"
              alt="Hound Oz"
              className="h-24 sm:h-28 w-auto"
            />
          </Link>
        </div>

        <div className="flex items-center justify-end gap-5 flex-1">
          <div className="hidden md:flex items-center gap-7">
            {NAV_LINKS.slice(3).map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`group font-bubble font-bold text-base inline-block px-2 py-3 -my-1 ${
                  pathname === l.to ? "text-maroon-dark" : "text-maroon"
                }`}
              >
                <span className="inline-block transition-transform group-hover:-translate-y-0.5 group-hover:-rotate-3">{l.label}</span>
              </Link>
            ))}
          </div>
          <button
            data-testid="cart-button"
            onClick={() => setOpen(true)}
            className="relative text-inkbrown hover:text-maroon transition-colors"
            aria-label="Open cart"
          >
            <ShoppingBag className="w-5 h-5" strokeWidth={1.5} />
            {count > 0 && (
              <span className="absolute -top-2 -right-2 bg-maroon text-cream text-[10px] w-4 h-4 rounded-full flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          <button
            className="md:hidden text-inkbrown"
            onClick={() => setMobileOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {mobileOpen ? <X className="w-6 h-6" strokeWidth={1.5} /> : <Menu className="w-6 h-6" strokeWidth={1.5} />}
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden border-t border-rosegold/15 bg-cream px-6 py-4 flex flex-col gap-3">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setMobileOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-bubble font-bold text-xl py-2 text-maroon transition-transform hover:-translate-y-0.5 hover:-rotate-3 inline-block"
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
